import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyBtn", "annualBtn", "monthlyPrice", "annualPrice", "intervalInput"]

  selectMonthly() {
    this.monthlyBtnTarget.classList.add("bg-white/10", "text-white")
    this.monthlyBtnTarget.classList.remove("text-slate-400", "hover:text-white")
    this.annualBtnTarget.classList.remove("bg-white/10", "text-white")
    this.annualBtnTarget.classList.add("text-slate-400", "hover:text-white")

    this.monthlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.annualPriceTargets.forEach(el => el.classList.add("hidden"))
    this.intervalInputTargets.forEach(el => el.value = "month")
  }

  selectAnnual() {
    this.annualBtnTarget.classList.add("bg-white/10", "text-white")
    this.annualBtnTarget.classList.remove("text-slate-400", "hover:text-white")
    this.monthlyBtnTarget.classList.remove("bg-white/10", "text-white")
    this.monthlyBtnTarget.classList.add("text-slate-400", "hover:text-white")

    this.annualPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.monthlyPriceTargets.forEach(el => el.classList.add("hidden"))
    this.intervalInputTargets.forEach(el => el.value = "year")
  }
}
